import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "submission-routing-bars" };
import { computed } from "vue";
import IntakeTagBar from "@/components/dashboard/IntakeTagBar.vue";
import AssigneeBar from "@/components/dashboard/AssigneeBar.vue";
import GroupBar from "@/components/dashboard/GroupBar.vue";
import { useRequirementsStore } from "@/stores/requirementsStore";
export default /*@__PURE__*/ _defineComponent({
    __name: 'SubmissionRoutingBars',
    props: {
        orderInfo: {}
    },
    emits: ["update-order-info-field"],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        const requirementsStore = useRequirementsStore();
        const tagDefs = computed(() => requirementsStore.clientConfig?.priorAuth?.availableTags || []);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(IntakeTagBar, {
                    tags: __props.orderInfo.statusTags || [],
                    "tag-defs": tagDefs.value,
                    "tag-due-dates": __props.orderInfo.tagDueDates || [],
                    "entity-type": "submission",
                    "entity-id": __props.orderInfo.orderKey,
                    "onUpdate:tags": _cache[0] || (_cache[0] = ($event) => (emit('update-order-info-field', 'statusTags', $event))),
                    "onUpdate:tagDueDates": _cache[1] || (_cache[1] = ($event) => (emit('update-order-info-field', 'tagDueDates', $event)))
                }, null, 8, ["tags", "tag-defs", "tag-due-dates", "entity-id"]),
                _createVNode(AssigneeBar, {
                    assignees: __props.orderInfo.assignees || [],
                    "entity-type": "submission",
                    "entity-id": __props.orderInfo.orderKey,
                    "onUpdate:assignees": _cache[2] || (_cache[2] = ($event) => (emit('update-order-info-field', 'assignees', $event)))
                }, null, 8, ["assignees", "entity-id"]),
                _createVNode(GroupBar, {
                    "assigned-groups": __props.orderInfo.assignedGroups || [],
                    "entity-type": "submission",
                    "entity-id": __props.orderInfo.orderKey,
                    "onUpdate:assignedGroups": _cache[3] || (_cache[3] = ($event) => (emit('update-order-info-field', 'assignedGroups', $event)))
                }, null, 8, ["assigned-groups", "entity-id"])
            ]));
        };
    }
});
